import type { ConfirmAppointmentRow } from "../../../_shared/_logic/confirm-appointments-contract"
import type {
  ConfirmAppointmentsIntent,
  ConfirmOnsiteContactSelection,
} from "../actions/confirmAppointments"

const normalizeText = (value: unknown) => String(value ?? "").trim()

export const buildOnsiteContact = (
  selection: ConfirmOnsiteContactSelection,
): ScheduleEventParticipantInputPayload | null => {
  if (!selection.enabled || selection.value === "none") return null

  if (selection.value === "custom") {
    const displayName = normalizeText(selection.customName)
    const email = normalizeText(selection.customEmail)
    const phone = normalizeText(selection.customPhone)

    if (!displayName && !email && !phone) return null

    return {
      display_name: displayName || null,
      email: email || null,
      phone: phone || null,
    }
  }

  const selectedOption = selection.selectedOption

  if (!selectedOption) return null

  const displayName =
    normalizeText(selectedOption.customer?.display_name) ||
    normalizeText(selectedOption.recipient.display_name) ||
    normalizeText(selectedOption.recipient.full_name) ||
    null
  const pointValue = (point: ContactPoint | null) =>
    normalizeText(point?.value) || normalizeText(point?.normalized_value)
  const email = pointValue(selectedOption.email)
  const phone = pointValue(selectedOption.phone)

  return {
    display_name: displayName,
    customer_id: selectedOption.recipient.customer_id,
    contact_point_id: selectedOption.email?.id ?? selectedOption.phone?.id ?? null,
    email: email || null,
    phone: phone || null,
  }
}

export const buildConfirmAppointmentsIntent = ({
  rows,
  onsiteContactSelection,
}: {
  rows: ConfirmAppointmentRow[]
  onsiteContactSelection: ConfirmOnsiteContactSelection
}): ConfirmAppointmentsIntent => {
  if (!rows.length) {
    return {
      kind: "blocked",
      label: "Termine bestätigen",
      disabled: true,
      disabledReason: "Keine bestätigbaren Termine vorhanden.",
      message: "Keine bestätigbaren Termine vorhanden.",
    }
  }

  const onsiteContact = buildOnsiteContact(onsiteContactSelection)

  return {
    kind: "commit",
    label: "Termine bestätigen",
    disabled: false,
    disabledReason: null,
    rows,
    items: rows.map((row) => ({
      event_id: row.event.id,
      onsite_contact: rows.length === 1 ? onsiteContact : null,
    })),
  }
}
